<template>
  <div
    v-if="canEndTurn"
    class="end-turn-button-container"
  >
    <o-button
      @click="onClickEndTurn"
      class="end-turn-button"
      stretch
    >
      <template v-if="showBuyingStocksButton">
        Buy Stocks And End Your Turn
      </template>
      <template v-else>
        End Your Turn
      </template>
    </o-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import OButton from "@/components/OButton";
import {NS_GAME_STATE, NS_TURN_STATE} from "@/store/constants";

export default {
  name: 'CompleteTurn',

  components: {
    OButton
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'isBuyingStocks',
      'isMyTurn',
      'stocksToBePurchased',
    ]),

    canEndTurn() {
      return this.isMyTurn && this.isBuyingStocks;
    },

    showBuyingStocksButton() {
      return this.stocksToBePurchased.length > 0;
    }
  },

  methods: {
    ...mapActions(NS_TURN_STATE, [
      'flowEndTurn'
    ]),

    onClickEndTurn() {
      this.flowEndTurn();
    },
  }
}
</script>

<style scoped>
.end-turn-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.end-turn-button {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 3;
}

@media screen and (min-width: 587px) {
  .end-turn-button {
    bottom: 50px;
    width: 50%;
    border: 2px solid white;
    border-radius: 5px;
    box-shadow: 1px 1px 5px black;
  }
}
</style>
